

















import { Component, Vue, Prop } from "vue-property-decorator";
import { point } from "./point";



@Component
export default class connection_arrow extends Vue {
  @Prop({ required: true }) public from!: point;
  @Prop({ required: true }) public to!: point;
  @Prop({ default: false }) public isTemp!: boolean;
  @Prop({ default: false }) public selected!: boolean;

  get svgStyle() {
    const left = Math.min(this.from.x, this.to.x) - 40;
    const top = Math.min(this.from.y, this.to.y) - 40;
    const right = Math.max(this.from.x, this.to.x) + 40;
    const bottom = Math.max(this.from.y, this.to.y) + 40;

    return {
      position: "absolute",
      left: left + "px",
      top: top + "px",
      width: (right - left) + "px",
      height: (bottom - top) + "px",
      overflow: "visible",
      // IMPORTANTE: permitir clicks sobre la línea
      pointerEvents: "none"
    };
  }

  get pathD(): string {
    const p1 = this.from;
    const p2 = this.to;
    const dx = Math.max(60, Math.abs(p2.x - p1.x) * 0.4);
    const c1x = p1.x + dx;
    const c1y = p1.y;
    const c2x = p2.x - dx;
    const c2y = p2.y;

    const bboxLeft = Math.min(p1.x, p2.x) - 40;
    const bboxTop = Math.min(p1.y, p2.y) - 40;

    const x1 = p1.x - bboxLeft;
    const y1 = p1.y - bboxTop;
    const x2 = p2.x - bboxLeft;
    const y2 = p2.y - bboxTop;
    const cx1 = c1x - bboxLeft;
    const cy1 = c1y - bboxTop;
    const cx2 = c2x - bboxLeft;
    const cy2 = c2y - bboxTop;

    return "M " + x1 + " " + y1 + " C " + cx1 + " " + cy1 + ", " + cx2 + " " + cy2 + ", " + x2 + " " + y2;
  }

  // Eventos para selección/eliminación
  public onClick() {
    this.$emit("select");
  }
  public onDblClick() {
    this.$emit("requestDelete");
  }
}
